export enum PageName {
    KITCHEN_SINK = 'lokaltestside',
    NOT_FOUND = '404',
}
